import style from "./style.module.css"
import BaseApi from "src/services/Api";
import React, { useEffect } from "react";
import { toast } from "react-toastify";

const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],
};  

export default function FrontHistory (props) {


    return (
        <>
        <div>
            <div className={style.introduction}>
                <div  className={style.text}>
                    <h4>{props.historyData.title}</h4>
                    <span>{props.historyData.text}</span>
                </div>
                <div className={style.imagePosition}>
                    <div className={style.masking}>
                        <img src={props.historyData.image} className={style.imgMask} alt="animais" />
                    </div>
                </div>
            </div>
            <div className={style.rectangle}>
                <div className={style.column}>
                <div className={style.organization}>
                    <div className={style.mmvDiv}>
                        <span className={style.mmv}>MISSÃO</span>
                    </div>
                    <div>
                        <span>{props.historyData.mission}</span>
                    </div>
                    <div className={style.valueDiv}>
                        <div className="d-flex flex-column">
                            <span className={style.number}>+{props.historyData.number_available}</span>
                            <span className={style.index}>ANIMAIS DISPONÍVEIS</span>
                        </div>
                    </div>
                </div>
                </div>
                
                <div className={style.column}>
                    <div className={style.organization}>
                        <div  className={style.mmvDiv}>
                            <span className={style.mmv}>VALORES</span>
                        </div>
                        <div>
                            <span>{props.historyData.values}</span>
                        </div>
                        <div className={style.valueDiv}> 
                            <div className="d-flex flex-column">
                                <span className={style.number}>+{props.historyData.number_animals}</span>
                                <span className={style.index}>ANIMAIS ADOTADOS</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={style.column}>
                    <div className={style.organization}>
                        <div  className={style.mmvDiv}>
                            <span className={style.mmv}>VISÃO</span>
                        </div>
                        <div>
                            <span>{props.historyData.vision}</span>
                        </div>
                        <div className={style.valueDiv}>
                            <div className="d-flex flex-column">
                                <span className={style.number}>+{props.historyData.number_rescues}</span>
                                <span className={style.index}>ANIMAIS RESGATADOS</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}